import React, { Component } from "react";
import ReeValidate from 'ree-validate'
import {convertReadbleFormat} from './../helpers';
const $ = window.$;
class Login extends Component {

  constructor(props) {
    super(props)
    this.validator = new ReeValidate({
      email: 'required|email',
      password: 'required|min:3',
    })
    this.state = {
      formData: {
        email: '',
        password: '',
      },
      formErrors: this.validator.errors
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    const { removeError, history } = this.props
    removeError && removeError();
    const { formData } = this.state
    const { errors } = this.validator
    this.validator.validateAll(formData)
      .then(success => {
        if (success) {
          this.props.onAuth("signin", {
            email: formData.email.toLowerCase(),
            password: formData.password
          }).then(() => {
            $('#login').modal('hide');
            history.push("/build/workout")
          }).catch(() => {
            return
          })
        } else {
          this.setState({ formErrors: errors })
        }
      })
  }

  componentDidMount() {
    const { errors } = this.validator
    $('#login').on('shown.bs.modal', () => {
      $("#email").focus();
    })
    $('#login').on('hidden.bs.modal', () => {
      this.setState({
        formData: {
          email: '',
          password: '',
        }
      }, () => {
        errors.clear();
        this.props.removeError();
      });
    })
  }

  handleChange = e => {
    const elName = e.target.name
    const elValue = e.target.value
    const { errors } = this.validator
    errors.remove(elName)
    this.setState({ formData: { ...this.state.formData, [elName]: elValue } })
    this.validator.validate(elName, elValue)
      .then(() => {
        this.setState({ formErrors: errors })
      })
  }

  closeModal = () => {
    this.validator.errors.clear();
    this.props.removeError();
    this.setState(
      {
        formData: { email: '', password: '' },
        formErrors: this.validator.errors
      },
      () => $('#login').modal('hide')
    );
  }

  render() {

    const { formData, formErrors } = this.state
    const { errors } = this.props

    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={this.closeModal}>&times;</button>
            <h3>Log into Fitbanx.</h3>
          </div>
          <div style={{ 'padding': '50px' }} className="modal-body">
            {errors && errors.message && <div className="alert alert-danger">{errors.message}</div>}
            <form onSubmit={this.handleSubmit} noValidate>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input type="email"
                  className="form-control"
                  id="email"
                  placeholder="Enter email"
                  name="email"
                  onChange={this.handleChange}
                  required
                  autoFocus
                  value={formData.email} />
                {formErrors.has('email') &&
                  <span className="error text-danger">{convertReadbleFormat(formErrors.first('email'))}</span>
                }
              </div>

              <div className="form-group">
                <label htmlFor="password">Password:</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  placeholder="Enter password"
                  onChange={this.handleChange}
                  required
                  value={formData.password}
                />
                {formErrors.has('password') &&
                  <span className="error text-danger">{convertReadbleFormat(formErrors.first('password'))}</span>
                }
              </div>
              <div className="row">
                <div className="col-md-6">
                  {/* <div className="checkbox">
            <label><input style={{'minHeight':'auto'}} type="checkbox" name="remember"/> Remember me</label>
            </div> */}
                </div>
                <div className="col-md-6 text-right">
                  <p><a data-toggle="modal" data-target="#forgotPassword" onClick={this.closeModal}>Forgot Password</a></p>
                </div>
              </div>
              <button style={{ 'width': '100%' }} type="submit" className="btn circle btn-light border btn-md">Log in</button>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" onClick={this.closeModal}>Close</button>
          </div>
        </div>

      </div>

    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/modals/login.js